import api from "../../../services/api";

// ===== MY TASKS =====
export const getMyAssignedTasks = () =>
  api.get("/work-task-assignments/my-tasks");